import type { FaireProductEntity } from "../../entity_types/product";

export const p_dhbkpw6up4: FaireProductEntity = {
  token: "p_dhbkpw6up4",
  type: "product",
  name: "On The Vine Tomato Memo Pad - Grocery List Notepad",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/37904621bb0cbe9bacd5fde229a3922abc002935a12b178ce115c776e7a89bf9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fbbac65e4f72e22b683c8e329e1c56816e4b0e3c7091acaa4c28e51b0ca18b52.jpeg",
    "https://cdn.faire.com/fastly/741ee1d0526cf5abe253674827de5845ad934205d3543f4bccb5e7fc5a90febd.jpeg"
  ],
  priceDollars: 7,
  description: "Gone are the days of boring stationery and uninspired to-do lists. This Tomato Grocery List Notepad brings a pop of color to your everyday planning, featuring bright illustrated tomatoes on the vine set against a bold background. Designed to live happily on your fridge, kitchen counter, or desk, it makes grocery runs and daily notes feel a little more delightful.\n\nThis kitchen memo pad is equal parts practical and giftable—perfect for home cooks, food lovers, gardeners, and anyone who appreciates playful food-themed stationery. Keep one by the fridge for shopping lists, tear off a page for market trips, or tuck it into your favorite cookbook as a bookmark.\n\nA charming little foodie gift that also merchandises beautifully alongside our sticky notes and notebooks.\n\nGood to know:\n\n• Measures 3.5\" × 8.5\"\n• Printed in full color on high-quality paper\n• Padded with sturdy cardboard backing\n• Packaged in a protective cellophane sleeve with a descriptive sticker on the front\n",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:34:00.010Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
